export enum MsgboxEnum {
	CANCEL = 'Abbrechen',
	CLOSE = 'Schließen',
	OK = 'OK',
	JA = 'Ja',
	NEIN = 'Nein',
	FERTIGSTELLEN = 'Fertigstellen'
}
